var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.69513 4.3053L9.99981 8.60998L14.3045 4.3053C14.6889 3.92089 15.3105 3.92089 15.6949 4.3053C16.0794 4.6897 16.0794 5.31133 15.6949 5.69574L11.3903 10.0004L15.6949 14.3051C16.0794 14.6895 16.0794 15.3112 15.6949 15.6956C15.5033 15.8873 15.2513 15.9837 14.9997 15.9837C14.7481 15.9837 14.4962 15.8873 14.3045 15.6956L9.99981 11.3909L5.69513 15.6956C5.50343 15.8873 5.25148 15.9837 4.9999 15.9837C4.74832 15.9837 4.49637 15.8873 4.30468 15.6956C3.92027 15.3112 3.92027 14.6895 4.30468 14.3051L8.60937 10.0004L4.30468 5.69574C3.92027 5.31133 3.92027 4.6897 4.30468 4.3053C4.68909 3.92089 5.31072 3.92089 5.69513 4.3053Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.e958ddbeabfe9112b90e69a044ba39e7.svg";
export { ForwardRef as ReactComponent };